const fetchJSON = async (url, options = {}) => {
  // WORKAROUND: In Jest with jest-fixed-jsdom, jsdom's AbortSignal isn't compatible
  // with Node's native fetch. Remove signal from options in tests.
  // Tracking: https://github.com/mswjs/jest-fixed-jsdom/issues/37
  //           https://github.com/jsdom/jsdom/issues/3682
  const { signal, ...otherOptions } = typeof __JEST__ !== 'undefined' ? { ...options, signal: undefined } : options;

  const response = await fetch(url, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    ...otherOptions,
    ...(signal ? { signal } : {})
  });

  if (!response.ok) {
    if (response.status === 401) {
      window.location.reload();
      return new Promise(() => {}); // Prevent further execution while reloading
    }
    throw new Error(`HTTP Error: ${response.status}`);
  }

  return response.json();
};

export default fetchJSON;
